// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__2zUn0","fullScreen":"style_fullScreen__2BjFB","hidden":"style_hidden__2dF1l"};